import React from 'react';
import { ChevronRight, CheckCircle } from 'lucide-react';
import { Link } from 'react-router-dom';
import { buttonClasses } from './ui/Button';
import { Card, CardContent, CardFooter } from './ui/Card';
// Helper component for the score display
interface CircularScoreProps {
  score: number;
  size?: number;
  strokeWidth?: number;
  className?: string;
}
export function CircularScore({
  score,
  className = ''
}: CircularScoreProps) {
  return <div className={`flex flex-col items-end ${className}`} data-id="element-251">
      <span className="flex items-baseline gap-0.5" data-id="element-252">
        <span className="text-2xl font-bold text-coral leading-none" data-id="element-253">
          {score}
        </span>
        <span className="text-xs text-muted-foreground" data-id="element-254">/100</span>
      </span>
      <span className="text-[11px] font-medium mt-1 text-muted-foreground" data-id="element-255">
        {score >= 90 ? 'Qualità eccellente' : score >= 70 ? 'Buona qualità' : score >= 50 ? 'Qualità sufficiente' : 'Qualità da migliorare'}
      </span>
    </div>;
}
export function LastCleaningWidget() {
  return <div className="mb-8" data-id="element-256">
      <h2 className="text-sm font-semibold text-foreground mb-3" data-id="element-257">
        Ultima pulizia eseguita
      </h2>

      <Card data-id="element-258">
        <CardContent noPadding data-id="element-259">
          <Link to="/pulizia-dettaglio?status=completata" className="flex items-center gap-4 p-4 hover:bg-muted/30 transition-all" data-id="element-260">
            {/* Date block */}
            <div className="flex-shrink-0 w-14 text-center border border-border rounded-lg py-2 px-1.5" data-id="element-261">
              <div className="text-[10px] uppercase tracking-wider font-medium text-muted-foreground" data-id="element-262">
                Oggi
              </div>
              <div className="text-2xl font-bold text-foreground leading-tight" data-id="element-263">
                15
              </div>
              <div className="text-[11px] text-muted-foreground" data-id="element-264">Gen</div>
            </div>

            {/* Info column */}
            <div className="flex-1 min-w-0" data-id="element-265">
              <div className="text-sm font-semibold text-foreground" data-id="element-266">
                10:30 – 13:00
              </div>
              <div className="flex items-center gap-2 text-sm text-muted-foreground mt-1" data-id="element-267">
                <img src="https://cdn.magicpatterns.com/uploads/g4qUZyyXcdzW3wf29pvDcz/Screenshot_2026-03-22_alle_16.12.18.png" alt="Francesca N." className="w-8 h-8 rounded-full object-cover flex-shrink-0" data-id="element-268" />
                Francesca N. · 2h 30m
              </div>
            </div>

            {/* Right column – score */}
            <CircularScore score={98} data-id="element-269" />

            {/* Chevron hint */}
            <ChevronRight size={18} className="text-muted-foreground flex-shrink-0" data-id="element-270" />
          </Link>
        </CardContent>

        {/* Footer: Checklist progress */}
        <CardFooter data-id="element-271">
          <div className="flex items-center gap-2 flex-shrink-0" data-id="element-272">
            <CheckCircle size={18} className="text-foreground" data-id="element-273" />
            <span className="text-sm text-foreground font-medium" data-id="element-274">
              Checklist
            </span>
            <span className="text-xs text-muted-foreground font-medium bg-muted rounded-full px-2 py-0.5" data-id="element-275">
              12/12
            </span>
          </div>

          <Link to="/pulizia-dettaglio?status=completata" className={buttonClasses({
          variant: 'outline',
          size: 'sm'
        })} data-id="element-276">
            Dettaglio
            <ChevronRight size={16} data-id="element-277" />
          </Link>
        </CardFooter>
      </Card>
    </div>;
}